export default __webpack_public_path__ + "static/media/pawn_knight_bg.a35f6688.png";